var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{attrs:{"color":_vm.avatarColor,"size":"28"}},[_c('span',{staticClass:"white--text",staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.userInitials)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }